module.exports = __webpack_public_path__ + "img/settingbutton.344dd326.png";